import { FC } from 'react';

/**
 * "Mostrar valores" dos gráficos de linha: desligado, a linha mostra o número do último dia e
 * dos extremos; ligado, de todos os pontos. Cada gráfico tem o seu.
 */
const BotaoValores: FC<{ ativo: boolean; onAlternar: () => void; testId?: string }> = ({
  ativo,
  onAlternar,
  testId,
}) => (
  <button
    type="button"
    aria-pressed={ativo}
    onClick={onAlternar}
    data-testid={testId}
    title={ativo ? 'Mostrar só o último dia e os extremos' : 'Mostrar o número de todos os pontos'}
    className={`inline-flex items-center gap-1 rounded-lg border px-2.5 py-1 text-xs transition-colors ${
      ativo
        ? 'border-theme-border bg-surface-hover font-medium text-content-primary'
        : 'border-theme-border text-content-secondary hover:bg-surface-hover'
    }`}
  >
    <span aria-hidden className="material-symbols-outlined text-[16px] leading-none">
      {ativo ? 'visibility_off' : 'pin'}
    </span>
    {ativo ? 'Só destaques' : 'Mostrar valores'}
  </button>
);

export default BotaoValores;
